module.exports = __webpack_public_path__ + "img/brand_tiktok.a8648620.svg";